// export const KE_MOTOR_QUOTE_FORM = 'keMotorInsurance/quoteForm/';
export const NA_MOTOR_QUOTE_FORM = 'naMotorInsurance/quoteForm/';
export const NA_MOTOR_QUOTE_FORM_SET_VALUE = NA_MOTOR_QUOTE_FORM + 'setValue/';
export const NA_MOTOR_QUOTE_FORM_SET_VALID = NA_MOTOR_QUOTE_FORM + 'setValid/';
export const NA_MOTOR_QUOTE_ADD_COVER = NA_MOTOR_QUOTE_FORM + 'addCover/';
export const FORM_VALID_MOTOR_INSURANCE_QUOTE_FORM = 'naMotorInsurance/quoteForm/transition/formValid';
export const FORM_INVALID_MOTOR_INSURANCE_QUOTE_FORM = 'naMotorInsurance/quoteForm/transition/formInValid';
export const FORM_VALID_MOTOR_INSURANCE_QUOTE_SHARE_FORM = 'naMotorInsurance/shareQuoteForm/transition/formValid';
export const FORM_INVALID_MOTOR_INSURANCE_QUOTE_SHARE_FORM = 'naMotorInsurance/shareQuoteForm/transition/formInValid';
export const NA_MOTOR_INSURANCE_SHARE_QUOTE_VALUE = NA_MOTOR_QUOTE_FORM + 'shareQuote';
// export const KE_MOTOR_QUOTE_FORM_SET_VALUE = KE_MOTOR_QUOTE_FORM + 'setValue/';
// export const KE_MOTOR_QUOTE_FORM_SET_VALID = KE_MOTOR_QUOTE_FORM + 'setValid/';
export const TOKEN_IS_EXPIRED = 'motor/expiredAuth';

export const SET_CAR_MAKES_LIST_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'carMakesList';
export const SET_CAR_MAKES_LIST_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'carMakesList';
export const SET_CAR_MODEL_LIST_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'carModelsList';
export const SET_CAR_MODEL_LIST_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'carModelsList';

export const SET_SELECTED_FORM_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'selectedForm';

export const TRIGGER_GET_ALL_CAR_MAKES = NA_MOTOR_QUOTE_FORM + 'triggerCarMakes';
export const TRIGGER_GET_ALL_CAR_MODELS = NA_MOTOR_QUOTE_FORM + 'triggerCarModels';
export const TRIGGER_GET_VALUERS = NA_MOTOR_QUOTE_FORM + 'triggerValuers';
export const TRIGGER_GET_NA_VALUERS = NA_MOTOR_QUOTE_FORM + '/na/triggerValuers';
export const SET_VALUERS_LIST_SUCCESS = NA_MOTOR_QUOTE_FORM + 'valuersList';
export const API_SUCCESS_TRANSITION_VALUERS = NA_MOTOR_QUOTE_FORM + 'api/success/valuers';
export const API_PENDING_TRANSITION_VALUERS = NA_MOTOR_QUOTE_FORM + 'api/pending/valuers';
export const API_FAILURE_TRANSITION_VALUERS = NA_MOTOR_QUOTE_FORM + 'api/failure/valuers';

export const NA_MOTOR_INSURANCE_SIDEBAR_OPEN_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'sidebarOpen';

export const REINITIALIZE = NA_MOTOR_QUOTE_FORM + '/state/reinitialize';

// VALIDATE QUOTE FORM

export const transitionMotorInsuranceQuoteForm = {
    formValid: () => ({
        type: FORM_VALID_MOTOR_INSURANCE_QUOTE_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_MOTOR_INSURANCE_QUOTE_FORM,
    }),
};

export const transitionShareQuoteForm = {
    formInvalid: () => ({
        type: FORM_VALID_MOTOR_INSURANCE_QUOTE_SHARE_FORM,
    }),
    formValid: () => ({
        type: FORM_INVALID_MOTOR_INSURANCE_QUOTE_SHARE_FORM,
    }),
};

// API Calls actions
export const API_PENDING_TRANSITION_MOTOR_INSURANCE_QUOTE_FORM = `${NA_MOTOR_QUOTE_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_MOTOR_INSURANCE_QUOTE_FORM = `${NA_MOTOR_QUOTE_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_MOTOR_INSURANCE_QUOTE_FORM = `${NA_MOTOR_QUOTE_FORM_SET_VALUE}/apiTransition/failure`;
export const API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM = `${NA_MOTOR_INSURANCE_SHARE_QUOTE_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM = `${NA_MOTOR_INSURANCE_SHARE_QUOTE_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM = `${NA_MOTOR_INSURANCE_SHARE_QUOTE_VALUE}/apiTransition/failure`;

export const API_PENDING_TRANSITIONS_CAR_MAKES = `${SET_CAR_MAKES_LIST_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITIONS_CAR_MAKES = `${SET_CAR_MAKES_LIST_VALUE}/apiTransition/success`;
export const API_PENDING_TRANSITIONS_CAR_MODELS = `${SET_CAR_MODEL_LIST_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITIONS_CAR_MODELS = `${SET_CAR_MODEL_LIST_VALUE}/apiTransition/success`;

export const API_FAILURE_TRANSITIONS_CAR_MAKES = `${SET_CAR_MAKES_LIST_VALUE}/apiTransition/failure`;
export const API_FAILURE_TRANSITIONS_CAR_MODELS = `${SET_CAR_MODEL_LIST_VALUE}/apiTransition/failure`;

export const apiTransitionMotorInsuranceQuoteForm = {
    pending: () => ({
        type: API_PENDING_TRANSITION_MOTOR_INSURANCE_QUOTE_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_MOTOR_INSURANCE_QUOTE_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_MOTOR_INSURANCE_QUOTE_FORM,
    }),
};

export const apiTransitionShareQuoteForm = {
    pending: () => ({
        type: API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
};

// Car makes api transition
export const apiTransitionCarMakes = {
    pending: () => ({
        type: API_PENDING_TRANSITIONS_CAR_MAKES,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITIONS_CAR_MAKES,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITIONS_CAR_MAKES,
    }),
};

// Car makes api transition
export const apiTransitionCarModels = {
    pending: () => ({
        type: API_PENDING_TRANSITIONS_CAR_MODELS,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITIONS_CAR_MODELS,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITIONS_CAR_MODELS,
    }),
};

// Valuers makes api transition
export const apiTransitionValuers = {
    pending: () => ({
        type: API_PENDING_TRANSITION_VALUERS,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_VALUERS,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_VALUERS,
    }),
};

//calculated Data
export const COLLECT_MOTOR_INSURANCE_QUOTE_FORM_DATA = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'collectMotorInsuranceQuoteData';
// export const COLLECT_KE_MOTOR_INSURANCE_QUOTE_FORM_DATA = KE_MOTOR_QUOTE_FORM + 'collectMotorInsuranceQuoteData';
// export const COLLECT_KE_THIRD_PARTY_DATA = KE_MOTOR_QUOTE_FORM + 'collectMotorInsuranceThirdPartyQuoteData';
// export const COLLECT_NA_MOTOR_INSURANCE_QUOTE_FORM_DATA = KE_MOTOR_QUOTE_FORM + 'collectMotorInsuranceQuoteData';
// export const COLLECT_NA_THIRD_PARTY_DATA = KE_MOTOR_QUOTE_FORM + 'collectMotorInsuranceThirdPartyQuoteData';

export const SUBMIT_MOTOR_INSURANCE_QUOTE_SUCCESS = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'success';
export const SUBMIT_MOTOR_INSURANCE_QUOTE_FAILURE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'failure';
export const CALCULATE_MOTOR_INSURANCE_PREMIUM_SUCCESS = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'calculatePremiumSuccess';
export const CALCULATE_MOTOR_INSURANCE_PREMIUM_FAILURE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'failure';
export const COLLECT_SHARE_QUOTE_FORM_DATA = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'collectShareQuoteFormData';
export const SHARE_MOTOR_INSURANCE_QUOTE_SUCCESS = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'shareQuoteSuccess';
export const SHARE_MOTOR_INSURANCE_QUOTE_FAILURE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'shareQuoteFailure';
// export const TRIGGER_CALCULATE_MOTORCYCLE_PREMIUM = KE_MOTOR_QUOTE_FORM + 'triggerCalculateMotorCyclePremium';

export const collectMotorInsuranceQuoteData = () => ({
    type: COLLECT_MOTOR_INSURANCE_QUOTE_FORM_DATA,
});

export const collectMotorInsuranceKeQuoteData = () => ({ type: COLLECT_KE_MOTOR_INSURANCE_QUOTE_FORM_DATA });
export const collectMotorInsuranceNaQuoteData = () => ({ type: COLLECT_MOTOR_INSURANCE_QUOTE_FORM_DATA });
export const collectThirdPartyQuoteData = () => ({ type: COLLECT_KE_THIRD_PARTY_DATA });
export const collectShareQuoteFormData = () => ({
    type: COLLECT_SHARE_QUOTE_FORM_DATA,
});

export const submitMotorInsuranceQuoteSuccess = () => ({
    type: SUBMIT_MOTOR_INSURANCE_QUOTE_SUCCESS,
    value,
});

export const shareQuoteSuccess = (value) => ({
    type: SHARE_MOTOR_INSURANCE_QUOTE_SUCCESS,
    value,
});

export const shareQuoteFailure = (error) => ({
    type: SHARE_MOTOR_INSURANCE_QUOTE_FAILURE,
    error,
});

export const calculateMotorInsurancePremiumSuccess = (value) => ({
    type: CALCULATE_MOTOR_INSURANCE_PREMIUM_SUCCESS,
    value,
});

export const submitMotorInsuranceQuoteFailure = () => ({
    type: SUBMIT_MOTOR_INSURANCE_QUOTE_FAILURE,
    error,
});

export const addCover = (value) => ({
    type: NA_MOTOR_QUOTE_ADD_COVER,
    value,
});

// Form values
export const SET_PERSONAL_ACCIDENT_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'personalAccident';
export const SET_PERSONAL_ACCIDENT_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'personalAccident';
export const SET_FULL_NAME_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'fullNameValue';
export const SET_FULL_NAME_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'fullNameValid';
export const SET_CAR_MAKE_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'carMakeValue';
export const SET_CAR_MAKE_ID = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'carMakeId';
export const SET_CAR_MODEL_ID = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'carModelId';
export const SET_CAR_MAKE_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'carMakeValid';
export const SET_CAR_MODEL_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'carModelValue';
export const SET_CAR_MODEL_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'carModelValid';
export const SET_YEAR_OF_MANUFACTURE_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'yearOfManufactureValue';
export const SET_YEAR_OF_MANUFACTURE_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'yearOfManufactureValid';
export const SET_COVER_START_DATE_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'coverStartDateValue';
export const SET_COVER_START_DATE_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'coverStartDateValid';
export const SET_IS_CAR_VALUED_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'isCarValuedValue';
export const SET_IS_CAR_VALUED_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'isCarValuedValid';
export const SET_CAR_VALUER_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'carValuerValue';
export const SET_CAR_VALUER_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'carValuerValid';
export const SET_CAR_USE_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'carUseValue';
export const SET_CAR_USE_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'carUseValid';
export const SET_HAS_ALARM_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'hasAlarmValue';
export const SET_HAS_ALARM_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'hasAlarmValid';
export const SET_VALUATION_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'valuationValue';
export const SET_VALUATION_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'valuationValid';
export const SET_UNCOMMON_RISK_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'uncommonRiskValue';
export const SET_UNCOMMON_RISK_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'uncommonRiskValid';
export const SET_EXCESS_PROTECTOR_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'excessProtectorValue';
export const SET_EXCESS_PROTECTOR_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'excessProtectorValid';
export const SET_SHARE_EMAIL_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'shareEmailValue';
export const SET_SHARE_EMAIL_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'shareEmailValid';
export const SET_VIOLENCE_TERORISM_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'violenceAndTerrorismValue';
export const SET_VIOLENCE_TERORISM_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'violenceAndTerrorismValid';
export const SET_SELECTED_COVER_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'selectMotorCover';
export const SET_SELECTED_COVER_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'selectMotorCover';
export const SET_IS_RARE_MODEL_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'isRareModel';
export const SET_IS_RARE_MODEL_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'isRareModel';
export const SET_OTHER_VALUER_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'otherValuer';
export const SET_OTHER_VALUER_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'otherValuer';
export const SET_TRACKING_SYSTEM_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'trackingSystem';
export const SET_TRACKING_SYSTEM_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'trackingSystem';
export const SET_OUTSIDE_EA_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'outsideEa';
export const SET_OUTSIDE_EA_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'outsideEa';
export const SET_COURTESY_CAR_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'courtesyCar';
export const SET_COURTESY_CAR_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'courtesyCar';
export const SET_COURTESY_CAR_AMOUNT_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'courtesyCarAmount';
export const SET_COURTESY_CAR_AMOUNT_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'courtesyCarAmount';

export const SET_VEHICLE_TYPE_VALUE = NA_MOTOR_QUOTE_FORM_SET_VALUE + 'vehicleType';
export const SET_VEHICLE_TYPE_VALID = NA_MOTOR_QUOTE_FORM_SET_VALID + 'vehicleType';

// action creators
export const setFullNameValue = (value) => ({
    type: SET_FULL_NAME_VALUE,
    value,
});

export const setFullNameValid = (error) => ({
    type: SET_FULL_NAME_VALID,
    error,
});

export const setCarMakeValue = (value) => ({
    type: SET_CAR_MAKE_VALUE,
    value,
});

export const setCarMakeId = (value) => ({
    type: SET_CAR_MAKE_ID,
    value,
});

export const setCarMakeValid = (error) => ({
    type: SET_CAR_MAKE_VALID,
    error,
});

export const setCarModelValue = (value) => ({
    type: SET_CAR_MODEL_VALUE,
    value,
});

export const setCarModelId = (value) => ({
    type: SET_CAR_MODEL_ID,
    value,
});


export const setCarModelValid = (error) => ({
    type: SET_CAR_MODEL_VALID,
    error,
});

export const setYearOfManufactureValue = (value) => ({
    type: SET_YEAR_OF_MANUFACTURE_VALUE,
    value,
});

export const setYearOfManufactureValid = (error) => ({
    type: SET_YEAR_OF_MANUFACTURE_VALID,
    error,
});

export const setCoverStartDateValue = (value) => ({
    type: SET_COVER_START_DATE_VALUE,
    value,
});

export const setCoverStartDateValid = (error) => ({
    type: SET_COVER_START_DATE_VALID,
    error,
});

export const setIsCarValuedValue = (value) => ({
    type: SET_IS_CAR_VALUED_VALUE,
    value,
});

export const setIsCarValuedValid = (error) => ({
    type: SET_IS_CAR_VALUED_VALID,
    error,
});

export const initializeQuoteForm = () => ({
    type: REINITIALIZE,
});

export const setCarValuerValue = (value) => ({
    type: SET_CAR_VALUER_VALUE,
    value,
});

export const setCarValuerValid = (error) => ({
    type: SET_CAR_VALUER_VALID,
    error,
});

export const setCarUseValue = (value) => ({
    type: SET_CAR_USE_VALUE,
    value,
});

export const setCarUseValid = (error) => ({
    type: SET_CAR_USE_VALID,
    error,
});

export const setHasAlarmValue = (value) => ({
    type: SET_HAS_ALARM_VALUE,
    value,
});

export const setHasAlarmValid = (error) => ({
    type: SET_HAS_ALARM_VALID,
    error,
});

export const setValuationValue = (value) => ({
    type: SET_VALUATION_VALUE,
    value,
});

export const setValuationValid = (error) => ({
    type: SET_VALUATION_VALID,
    error,
});

export const setUncommonRiskValue = (value) => ({
    type: SET_UNCOMMON_RISK_VALUE,
    value,
});

export const setUncommonRiskValid = (error) => ({
    type: SET_UNCOMMON_RISK_VALID,
    error,
});

export const setExcessProtectorValue = (value) => ({
    type: SET_EXCESS_PROTECTOR_VALUE,
    value,
});

export const setExcessProtectorValid = (error) => ({
    type: SET_EXCESS_PROTECTOR_VALID,
    error,
});

export const setViolenceAndTerrorismValue = (value) => ({
    type: SET_VIOLENCE_TERORISM_VALUE,
    value,
});

export const setViolenceAndTerrorismValid = (error) => ({
    type: SET_VIOLENCE_TERORISM_VALID,
    error,
});

export const setShareEmailValue = (value) => ({
    type: SET_SHARE_EMAIL_VALUE,
    value,
});

export const setShareEmailValid = (error) => ({
    type: SET_SHARE_EMAIL_VALID,
    error,
});

export const setIsRareModelValue = (value) => ({
    type: SET_IS_RARE_MODEL_VALUE,
    value,
});

export const setIsRareModelValid = (error) => ({
    type: SET_IS_RARE_MODEL_VALID,
    error,
});

export const setOtherValuerValue = (value) => ({
    type: SET_OTHER_VALUER_VALUE,
    value,
});

export const setOtherValuerValid = (error) => ({
    type: SET_OTHER_VALUER_VALID,
    error,
});

export const setTrackingSystemValue = (value) => ({
    type: SET_TRACKING_SYSTEM_VALUE,
    value,
});

export const setTrackingSystemValid = (error) => ({
    type: SET_TRACKING_SYSTEM_VALID,
    error,
});

export const setOutsideEaValue = (value) => ({
    type: SET_OUTSIDE_EA_VALUE,
    value,
});

export const setOutsideEaValid = (error) => ({
    type: SET_OUTSIDE_EA_VALID,
    error,
});

export const setExpiredAuth = (value) => ({
    type: TOKEN_IS_EXPIRED,
    value,
});

export const setSideBarOpen = (value) => ({ type: NA_MOTOR_INSURANCE_SIDEBAR_OPEN_VALUE, value });
export const setShowShareModal = (value) => ({ type: NA_MOTOR_INSURANCE_SHARE_QUOTE_VALUE, value });

export const setSelectedCoverValue = (value) => ({ type: SET_SELECTED_COVER_VALUE, value });
export const setSelectedCoverValid = (error) => ({ type: SET_SELECTED_COVER_VALID, error });
export const setCourtesyCarValue = (value) => ({ type: SET_COURTESY_CAR_VALUE, value });
export const setCourtesyCarValid = (error) => ({ type: SET_COURTESY_CAR_VALID, error });

export const setCourtesyCarAmountValue = (value) => ({ type: SET_COURTESY_CAR_AMOUNT_VALUE, value });
export const setCourtesyCarAmountValid = (error) => ({ type: SET_COURTESY_CAR_AMOUNT_VALID, error });
export const setVehicleTypeValue = (value) => ({
    type: SET_VEHICLE_TYPE_VALUE,
    value,
});

export const setVehicleTypeValid = (error) => ({
    type: SET_VEHICLE_TYPE_VALID,
    error,
});

export const triggerMotocyleInsurance = () => ({
    type: TRIGGER_CALCULATE_MOTORCYCLE_PREMIUM,
});

export const setCarMakesValue = (value) => ({
    type: SET_CAR_MAKES_LIST_VALUE,
    value,
});
export const setCarMakesValid = (error) => ({
    type: SET_CAR_MAKES_LIST_VALID,
    error,
});

export const setCarModelsValue = (value) => ({
    type: SET_CAR_MODEL_LIST_VALUE,
    value,
});
export const setCarModelsValid = (error) => ({
    type: SET_CAR_MODEL_LIST_VALID,
    error,
});

export const setselectedFormValue = (value) => ({
    type: SET_SELECTED_FORM_VALUE,
    value,
});

export const triggerGetCarModels = () => ({
    type: TRIGGER_GET_ALL_CAR_MODELS,
});

export const triggerGetCarMakes = () => ({
    type: TRIGGER_GET_ALL_CAR_MAKES,
});

export const triggerGetValuers = () => ({
    type: TRIGGER_GET_VALUERS,
});
export const triggerGetNaValuers = () => ({
    type: TRIGGER_GET_NA_VALUERS,
});
export const setValuers = (value) => ({
    type: SET_VALUERS_LIST_SUCCESS,
    value,
});

export const setPersonalAccidentValue = (value) => ({
    type: SET_PERSONAL_ACCIDENT_VALUE,
    value,
});

export const setPersonalAccidentValid = (error) => ({
    type: SET_PERSONAL_ACCIDENT_VALID,
    error,
});
